import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

import { FormTitle } from 'components/Core/Forms';
import { commaize } from 'utils/pricing';

const Container = styled.div`
  margin-bottom: 15px;
  border-bottom: 1px solid ${props => props.theme.lightGray};
`;

const RowDetail = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;
`;

const RowText = styled.p`
  font-size: 14px;
  ${props => props.label && `
    font-weight: 500;
  `}
  ${props => props.discount && `color: ${props.theme.red};`}
  ${props => props.total && `
    color: ${props.theme.orange};
    font-size: 18px;
  ;`}
  ${props => props.totalPrice && `
    font-weight: bold; 
  ;`}
`;

const PriceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
`;

const InsufficientText = styled.p`
  text-align: right;
  font-size: 18px;
  font-weight: bold;
  color: red;
  text-align: center;
  margin: 15px 0;
`;

const ProductPricing = props => {
  const { price, loading, credit } = props;
  return (
    <Container>
      <div>
        <FormTitle>Product Pricing</FormTitle>
        <RowDetail>
          <RowText label total>Total Price: </RowText>
          <PriceContainer>
            {loading ? <Spin /> : <RowText total totalPrice>{commaize(price.grandTotal)} THB</RowText>}
          </PriceContainer>
        </RowDetail>
        {!loading && credit < price.grandTotal && (
          <InsufficientText>
            Insufficient Credit (You have {commaize(credit)})
          </InsufficientText>
        )}
      </div>
    </Container>
  );
};

export default ProductPricing;



// WEBPACK FOOTER //
// ./src/components/Product/ProductPricing.js